import { useCallback, useEffect, useState, useRef, use } from "react";
import DashboardGreeting from "../DashboardGreeting";
import CommonService from "../../services/common.service";
import moment from "moment";

import SearchIcon from "../../assets/images/search.svg";

import { Card } from "react-bootstrap";
import { Empty, Skeleton } from "antd";

import { Form } from "react-bootstrap";
import { useStateContext } from "../../contexts/ContextProvider";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AllEmployeeTree from "./AllEmployeeTree";

const CompanyHierarchy = ({ user }) => {
  const navHeading = "Company Hierarchy";

  const [empList, setEmpList] = useState([]);
  const [allEmpList, setAllEmpList] = useState([]);

  const [loading, setLoading] = useState(false);

  const [allEmpCount, setAllEmpCount] = useState("");

  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  const [departmentList, setDepartmentList] = useState([]); 

  const contentRef = useRef(null);

  const [showAllEmpsTree, setShowAllEmpsTree] = useState(false);

  const [selectedLocation, setSelectedLocation] = useState("Pune");

  const [locations, setLocations] = useState([]);

  const [rmList, setRmList] = useState([]);
  const [hrList, setHRList] = useState([]);

  const marriedStatusOptions = [
    { label: "Married", value: "Married" },
    { label: "Unmarried", value: "Unmarried" },
  ];

   const platformOptions = [
    { label: "eSSL", value: "1" },
    { label: "Attendrix", value: "2" },
  ];


  const { employees } = useStateContext();

  const roles = [
    {
      label: "HR",
      value: "1",
    },
    {
      label: "Reporting Manager",
      value: "2",
    },
    {
      label: "Employee",
      value: "3",
    },
    {
      label: "Admin",
      value: "4",
    },
  ];

  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [open, setOpen] = useState(false);

  const [validated, setValidated] = useState(false);

  const [selectedEmpId, setSelectedEmpId] = useState("");

  const [leaveStatus, setLeaveStatus] = useState("1");

  const [selectedEmpData, setSelectedEmpData] = useState({});
  const [selectedEmpDataEdit, setSelectedEmpDataEdit] = useState({});

  // Profile image upload state
  const [profileFile, setProfileFile] = useState(null);
  const [profilePreview, setProfilePreview] = useState("");

  const [fullScreen, setFullScreen] = useState(false);

  const fileInputRef = useRef(null);

  useEffect(() => {
    const handleFullscreenChange = () => {
      const isFullscreen = !!document.fullscreenElement;
      if (!isFullscreen) {
        setFullScreen(false);
        if (contentRef.current) {
          const el = contentRef.current;
          // revert any styles we applied when entering fullscreen
          el.style.background = "";
          el.style.width = "";
          el.style.height = "";
        }
      }
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    document.addEventListener("mozfullscreenchange", handleFullscreenChange);
    document.addEventListener("MSFullscreenChange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "mozfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "MSFullscreenChange",
        handleFullscreenChange
      );
    };
  }, []);

  const triggerFileSelect = () => {
    if (fileInputRef.current) fileInputRef.current.click();
  };

  const fetchDepartmentList = useCallback(() => {
    CommonService.getAlldepts()
      .then((resp) => {
        if (resp.data) {
          setDepartmentList(resp.data);
        }
      })
      .catch((e) => console.log(e));
  }, []);

  const handleInputChnage = (e) => {
    const { name, value } = e.target;
    setSelectedEmpDataEdit((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Update gender when radio selection changes
  const handleGenderChange = (e) => {
    const { value } = e.target;
    setSelectedEmpDataEdit((prevData) => ({
      ...prevData,
      gender: value,
    }));
  };

  const handleChangeStatus = (e) => {
    const { name, checked } = e.target;
    setSelectedEmpDataEdit((prevData) => ({
      ...prevData,
      [name]: checked ? "1" : "0",
    }));
  };

  useEffect(() => {
    return () => {
      if (profilePreview) {
        try {
          URL.revokeObjectURL(profilePreview);
        } catch (e) {
          // ignore
        }
      }
    };
  }, [profilePreview]);

  useEffect(() => {
    fetchDepartmentList();
  }, [fetchDepartmentList]);

  const handleProfileChange = (e) => {
    const file = e.target.files && e.target.files[0];
    if (file) {
      if (profilePreview) {
        try {
          URL.revokeObjectURL(profilePreview);
        } catch (e) {}
      }
      const preview = URL.createObjectURL(file);
      setProfileFile(file);
      setProfilePreview(preview);
    }
  };

  const fetchLocations = useCallback(() => {
    CommonService.getAllLocations()
      .then((resp) => {
        const locationsData = resp.data.map((item) => ({
          label: item.location,
          value: item.location,
        }));
        setLocations(locationsData);
      })
      .catch((e) => console.log(e));
  }, []);

  useEffect(() => {
    fetchLocations();
  }, [fetchLocations]);

  useEffect(() => {
    const hrLists = employees
      .filter((item) => item.department === "HR")
      .map((item2) => ({
        label: item2.name,
        value: item2.empId,
      }));
    // console.log("hrLists", employees, hrLists)
    setHRList(hrLists);
  }, [employees]);

  const fetchAllEmpList = (leaveStatus) => {
    const payload = {
      location: "",
    };
    CommonService.getEmpBasicInfoByLoc(payload).then((resp) => {
      if (resp.data) {
        const statusPriority = {
          Present: "1",
          OnLeave: "1",
          Resigned: "2",
        };

        const data = resp.data.filter(
          (item) => statusPriority[item.leaveStatus] === leaveStatus
        );

        setAllEmpCount(data);
      }
    });
  };

  const fetchRmList = () => {
    CommonService.GetRmList()
      .then((resp) => {
        if (resp.data) {
          const rmlists = resp.data.map((item) => ({
            label: item.name,
            value: item.empid,
          }));
          setRmList(rmlists);
        }
      })
      .catch((e) => console.log(e));
  };

  // console.log("rmList", rmList)

  const fetchEmpList = (location, designation, leaveStatus) => {
    const payload = {
      location: location === "All" ? "" : location,
    };
    setLoading(true);
    CommonService.getEmpBasicInfoByLoc(payload)
      .then((resp) => {
        if (resp.data) {
          const order = { CTO: 1, HR: 2 };
          const sortedEmployees = resp.data.sort((a, b) => {
            return (order[a.designation] || 99) - (order[b.designation] || 99);
          });

          const rmlists = resp.data
            .filter((item) => item.userRole === "Reporting Manager")
            .map((item2) => ({
              label: item2.name,
              value: item2.empId,
            }));

          // setRmList(rmlists);

          const priority = {
            "Bussiness Development": 1,
            HR: 2,
            "IT Adminstrator": 3,
            Technical: 4,
            "UI/UX": 5,
            ID: 6,
            Articulate: 7,
            Media: 8,
          };

          const sortedData = sortedEmployees.sort((a, b) => {
            return (
              (priority[a.department] || 99) - (priority[b.department] || 99)
            );
          });

          const statusPriority = {
            Present: "1",
            OnLeave: "1",
            Resigned: "2",
          };

          let sortedByLeaveStatus = sortedData.filter(
            (item) => statusPriority[item.leaveStatus] === leaveStatus
          );

          let dataEntryOperator =
            allEmpCount &&
            allEmpCount.filter(
              (item) =>
                item.designation === "Data Entry operator" &&
                statusPriority[item.leaveStatus] === leaveStatus
            );

          const locationWiseData = Object.values(
            sortedByLeaveStatus.reduce((acc, emp) => {
              if (!acc[emp.location]) {
                acc[emp.location] = {
                  location: emp.location,
                  sortedByLeaveStatus: [],
                  presentCount: 0,
                  resignedCount: 0,
                };
              }
              acc[emp.location].sortedByLeaveStatus.push(emp);
              // Count present and absent
              if (
                emp.leaveStatus === "Present" ||
                emp.leaveStatus === "OnLeave"
              ) {
                acc[emp.location].presentCount += 1;
              } else if (emp.leaveStatus === "Resigned") {
                acc[emp.location].resignedCount += 1;
              }
              return acc;
            }, {})
          );
          setAllEmpList(locationWiseData);

          if (designation === "Data Entry Operator") {
            setEmpList(dataEntryOperator);
          } else {
            setEmpList(sortedByLeaveStatus);
          }

          setLoading(false);
        }
      })
      .catch((e) => console.log(e), setLoading(false));
  };

  const fetchEmpDataEdit = (empId) => {
    const payload = {
      EmpId: empId,
    };
    CommonService.getEmpDetailsForUpd(payload)
      .then((resp) => {
        if (resp.data) {
          setSelectedEmpDataEdit(resp.data[0]);
        }
      })
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    fetchEmpList(selectedLocation, "", leaveStatus);
  }, [selectedLocation, leaveStatus]);

  useEffect(() => {
    fetchAllEmpList("1");
    fetchRmList();
  }, []);

  const handleSelectChange = (e) => {
    // console.log(e.target.value);
    setShowAllEmpsTree(false);
    setSelectedLocation(e.target.value);
    setFullScreen(false);
    if (e.target.value === "Data Entry Operator") {
      fetchEmpList("Thane", "Data Entry Operator", leaveStatus);
    } else {
      fetchEmpList(e.target.value, "", leaveStatus);
    }
  };
  const handleSelectChange2 = (e) => {
    setLeaveStatus(e.target.value);
    fetchAllEmpList(e.target.value);
    if (selectedLocation === "Data Entry Operator") {
      fetchEmpList("Thane", "Data Entry Operator", e.target.value);
    } else {
      fetchEmpList(selectedLocation, "", e.target.value);
    }
  };

  const fetchSelectedEmpData = (empId) => {
    const paylaod = {
      EmpId: empId,
    };

    CommonService.getEmpDetailsByID(paylaod)
      .then((resp) => {
        if (resp.data) {
          setSelectedEmpData(resp.data[0]);
        }
      })
      .catch((e) => console.log(e));
  };

  const showModal = (empId) => {
    setShow(true);
    fetchSelectedEmpData(empId);
  };

  const moreContent = (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <div
        className="action-item"
        onClick={() => setShow2(true)}
        style={{
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: 8,
        }}
      >
        Edit
      </div>
    </div>
  );

  const handleSetOpen = (empid) => {
    // setOpen(!open);
    setShow2(true);
    setSelectedEmpId(empid);
    fetchEmpDataEdit(empid);
  };

  const handleUpdateProfile = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    const formdata = new FormData();
    formdata.append("EmpId", selectedEmpDataEdit.empId);
    formdata.append("Name", selectedEmpDataEdit.name);
    formdata.append("designation", selectedEmpDataEdit.designation);
    formdata.append("empProfilePic", profileFile);
    formdata.append("empProfilePicName", null);
    formdata.append("Email", selectedEmpDataEdit.email);
    formdata.append("department", selectedEmpDataEdit.department);
    formdata.append("Dob", selectedEmpDataEdit.dob);
    formdata.append("mobileno", selectedEmpDataEdit.mobileno);
    formdata.append("location", selectedEmpDataEdit.location);
    formdata.append("isActive", selectedEmpDataEdit.isActive);
    formdata.append("lastWorkDay", selectedEmpDataEdit.lastWorkDay);
    formdata.append("UserRoleId", selectedEmpDataEdit.userRoleId);
    formdata.append("RMid", selectedEmpDataEdit.rMid);
    formdata.append("HR_id", selectedEmpDataEdit.hR_id);
    formdata.append("isprobationsts", selectedEmpDataEdit.isprobationsts);
    formdata.append("joiningdate", selectedEmpDataEdit.joiningdate);
    formdata.append("Comfirmation_date", selectedEmpDataEdit.comfirmation_date);
    formdata.append("Maritial_Status", selectedEmpDataEdit.maritial_Status);
    formdata.append("Payroll", selectedEmpDataEdit.payroll);
    formdata.append("LeaveAllocateYear", selectedEmpDataEdit.leaveAllocateYear);
    formdata.append("allocatedLeave", selectedEmpDataEdit.allocatedLeave);
    formdata.append("yearlyBalLeave", selectedEmpDataEdit.yearlyBalLeave);
    formdata.append("Gender", selectedEmpDataEdit.gender);
    formdata.append(
      "emp_EsslDeviceCode",
      selectedEmpDataEdit.emp_EsslDeviceCode
    );

    formdata.append("platform", selectedEmpDataEdit.platform)

    // console.log(
    //   "formdata",
    //   selectedEmpDataEdit.isActive,
    //   selectedEmpDataEdit.lastWorkDay
    // );

    CommonService.updateEmpData(formdata)
      .then((resp) => {
        if (resp.data) {
          setProfilePreview("");
          toast.success("Emplployee Information Updated Successfully", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });

          fetchEmpList(selectedLocation, "", "1");
          setShow2(false);
        }
      })
      .catch((e) => console.log(e));
  };

  const goFullScreen = () => {
    if (contentRef.current) {
      setFullScreen(true);
      const element = contentRef.current;

      // Request fullscreen
      if (element.requestFullscreen) {
        element.requestFullscreen();
      }

      // Add white background when fullscreen is activated
      element.style.background = "#fff";
      element.style.width = "100%";
      element.style.height = "100%";
    } else {
      setFullScreen(false);
    }
  };

  const handleSearch = (e) => {
    const keyword = e.target.value.toLowerCase();
    setSearch(e.target.value);
    const filteredData = empList.filter(
      (row) =>
        (row.name && row.name.toLowerCase().includes(keyword)) ||
        (row.empid && row.empid.toLowerCase().includes(keyword)) ||
        (row.empId && row.empId.toLowerCase().includes(keyword)) ||
        (row.email && row.email.toLowerCase().includes(keyword))
    );
    if (keyword.length > 0) {
      setFilter(true);
    } else {
      setFilter(false);
    }
    setFilteredData(filteredData);
  };

  return (
    <>
      <div className="dashboard-container">
        <DashboardGreeting navHeading={navHeading} user={user} />
        <ToastContainer />
        <div className="filterBarNew">
          <div className="d-flex">
            {selectedLocation !== "All" && !showAllEmpsTree ? (
              <>
                {" "}
                <div className="searchBar">
                  <input
                    type="text"
                    placeholder="Search Employee name/ID/Email"
                    value={search}
                    onChange={handleSearch}
                  />
                  <span>
                    <img src={SearchIcon} alt="" />
                  </span>
                </div>
              </>
            ) : null}
          </div>
          <div className="filterBar mb-4">
            {showAllEmpsTree && (
              <>
                {" "}
                <div className="locations" onClick={goFullScreen}>
                  <span>Go Full Screen</span>
                </div>
              </>
            )}

            <div
              className="locations"
              onClick={(e) => setShowAllEmpsTree(true)}
            >
              <span>All Employees</span>
            </div>
            <div className="locations">
              <select
                className="location-select"
                value={selectedLocation}
                onChange={handleSelectChange}
              >
                <option value="All">All</option>
                <option value="Thane">Thane</option>
                <option value="Data Entry Operator">Data Entry Operator</option>
                {Array.isArray(locations)
                  ? locations.map((item) => {
                      return <option value={item.value}>{item.label}</option>;
                    })
                  : null}
              </select>
            </div>
            <div className="locations">
              <select
                className="location-select"
                value={leaveStatus}
                onChange={handleSelectChange2}
              >
                <option value="1">Active</option>
                <option value="2">Inactive</option>
              </select>
            </div>
          </div>
        </div>

        <div
          className="companyHierarchyStages scroll"
          style={{ height: "500px" }}
        >
          {showAllEmpsTree ? (
            <>
              <AllEmployeeTree
                contentRef={contentRef}
                fullScreen={fullScreen}
                leaveStatus={leaveStatus}
              />
            </>
          ) : (
            <>
              <div className="compInfo mb-3">
                <div className="d-flex gap-2">
                  <span>Aeon software</span>
                  <span>{allEmpCount && allEmpCount.length}</span>
                </div>
                <span>
                  <svg
                    width="6"
                    height="16"
                    viewBox="0 0 6 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3 16L5.88675 11L0.113248 11L3 16ZM2.5 -2.18557e-08L2.5 11.5L3.5 11.5L3.5 2.18557e-08L2.5 -2.18557e-08Z"
                      fill="#887B9D"
                    />
                  </svg>
                </span>
              </div>
              {selectedLocation !== "All" ? (
                <>
                  <div className="compInfo mb-3">
                    <span>
                      {selectedLocation} {empList.length}
                    </span>
                  </div>
                  <div className="list emp-cardlist">
                    <div className="row">
                      {loading ? (
                        <Skeleton active={loading} />
                      ) : empList.length === 0 ? (
                        <div className="d-flex align-items-center justify-content-center w-100">
                          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                        </div>
                      ) : (
                        <>
                          {Array.isArray(empList)
                            ? (filter ? filteredData : empList).map((item) => {
                                return (
                                  <>
                                    <div className="col-xl-3 col-lg-4 col-md-6 mb-4">
                                      <Card>
                                        <div className="top">
                                          <div
                                            className={
                                              "status " + item.leaveStatus
                                            }
                                          >
                                            <span>{item.leaveStatus}</span>
                                          </div>
                                          <button
                                            className="btn-transperent"
                                            onClick={() =>
                                              handleSetOpen(item.empId)
                                            }
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="16"
                                              fill="currentColor"
                                              className="bi bi-pencil-square"
                                              viewBox="0 0 16 16"
                                            >
                                              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                              <path
                                                fillRule="evenodd"
                                                d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                                              />
                                            </svg>
                                          </button>
                                        </div>
                                        <div className="profile">
                                          {item.empProfilePicName !== "" ? (
                                            <>
                                              <div className="p-circle">
                                                <img
                                                  src={`https://elmsbk.aeontechhub.com/ProfilePic/${item.empId}/${item.empProfilePicName}`}
                                                  width="75px"
                                                  alt=""
                                                />
                                              </div>
                                            </>
                                          ) : (
                                            <>
                                              {item.gender === "Male" ? (
                                                <>
                                                  <img
                                                    src="https://avatar.iran.liara.run/public/boy"
                                                    width="75px"
                                                    alt=""
                                                  />
                                                </>
                                              ) : (
                                                <>
                                                  <img
                                                    src="https://avatar.iran.liara.run/public/girl"
                                                    width="75px"
                                                    alt=""
                                                  />
                                                </>
                                              )}
                                            </>
                                          )}
                                          <div className="profile-info">
                                            <span className="name">
                                              {item.name}
                                            </span>
                                            <span className="desig">
                                              {item.designation}
                                            </span>
                                          </div>
                                        </div>
                                        <div className="emp-info2">
                                          <div className="d-flex gap-2">
                                            <span>#</span>
                                            <span>#{item.empId}</span>
                                          </div>
                                          <div className="d-flex gap-2">
                                            <span>
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16"
                                                height="16"
                                                fill="currentColor"
                                                className="bi bi-briefcase-fill"
                                                viewBox="0 0 16 16"
                                              >
                                                <path d="M6.5 1A1.5 1.5 0 0 0 5 2.5V3H1.5A1.5 1.5 0 0 0 0 4.5v1.384l7.614 2.03a1.5 1.5 0 0 0 .772 0L16 5.884V4.5A1.5 1.5 0 0 0 14.5 3H11v-.5A1.5 1.5 0 0 0 9.5 1zm0 1h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5" />
                                                <path d="M0 12.5A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5V6.85L8.129 8.947a.5.5 0 0 1-.258 0L0 6.85z" />
                                              </svg>
                                            </span>
                                            <span>{item.department}</span>
                                          </div>
                                          <div className="d-flex gap-2">
                                            {item.email ? (
                                              <>
                                                <span>
                                                  <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="16"
                                                    height="16"
                                                    fill="currentColor"
                                                    className="bi bi-envelope-fill"
                                                    viewBox="0 0 16 16"
                                                  >
                                                    <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414zM0 4.697v7.104l5.803-3.558zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586zm3.436-.586L16 11.801V4.697z" />
                                                  </svg>
                                                </span>
                                                <span>{item.email}</span>
                                              </>
                                            ) : (
                                              <>
                                                <span>&nbsp;</span>
                                                <span>&nbsp;</span>
                                              </>
                                            )}
                                          </div>
                                          <div className="d-flex gap-2">
                                            {item.mobile !== "" ? (
                                              <>
                                                <span>
                                                  <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="16"
                                                    height="16"
                                                    fill="currentColor"
                                                    className="bi bi-telephone-fill"
                                                    viewBox="0 0 16 16"
                                                  >
                                                    <path
                                                      fillRule="evenodd"
                                                      d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"
                                                    />
                                                  </svg>
                                                </span>
                                                <span>{item.mobile}</span>
                                              </>
                                            ) : (
                                              <>
                                                <span>&nbsp;</span>
                                                <span>&nbsp;</span>
                                              </>
                                            )}
                                          </div>
                                        </div>
                                        <div className="cta d-flex gap-2 align-items-center justify-content-between">
                                          <div className="joined-date">
                                            <span>
                                              Joined at
                                              <strong>
                                                {item.joiningDate !== "" && (
                                                  <>
                                                    {" "}
                                                    {moment(
                                                      item.joiningDate,
                                                      "YYYY-MM-DD"
                                                    ).format("D MMM YYYY")}
                                                  </>
                                                )}
                                              </strong>
                                            </span>
                                          </div>
                                          <button
                                            onClick={(e) => {
                                              showModal(item.empId);
                                            }}
                                            className="btn-transperent"
                                          >
                                            View Details
                                            <span>
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16"
                                                height="16"
                                                fill="currentColor"
                                                className="bi bi-arrow-right-short"
                                                viewBox="0 0 16 16"
                                              >
                                                <path
                                                  fillRule="evenodd"
                                                  d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8"
                                                />
                                              </svg>
                                            </span>
                                          </button>
                                        </div>
                                      </Card>
                                    </div>
                                  </>
                                );
                              })
                            : null}
                        </>
                      )}
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="scroll">
                    <div className="flex">
                      {Array.isArray(allEmpList)
                        ? allEmpList.map((item2) => {
                            return (
                              <>
                                <div className="item">
                                  <div className="compInfo mb-3">
                                    <span>{item2.location}</span>
                                    <span>
                                      {item2.sortedByLeaveStatus.length}
                                    </span>
                                    {/* <span title="Present" style={{color: 'green', fontWeight: 'bold'}}>{item2.presentCount}</span> */}
                                    {/* <span title="Resigned" style={{color: 'red', fontWeight: 'bold'}}>{item2.resignedCount}</span> */}
                                  </div>
                                  <div className="list emp-cardlist2">
                                    {loading ? (
                                      <Skeleton active={loading} />
                                    ) : allEmpList.length === 0 ? (
                                      <div className="d-flex align-items-center justify-content-center w-100">
                                        <Empty
                                          image={Empty.PRESENTED_IMAGE_SIMPLE}
                                        />
                                      </div>
                                    ) : (
                                      <>
                                        {Array.isArray(
                                          item2.sortedByLeaveStatus
                                        )
                                          ? item2.sortedByLeaveStatus.map(
                                              (item) => {
                                                return (
                                                  <>
                                                    <div className="mb-4">
                                                      <Card>
                                                        <div className="top">
                                                          <div
                                                            className={
                                                              "status " +
                                                              item.leaveStatus
                                                            }
                                                          >
                                                            <span>
                                                              {item.leaveStatus}
                                                            </span>
                                                          </div>
                                                        </div>
                                                        <div className="profile">
                                                          {item.empProfilePicName !==
                                                          "" ? (
                                                            <>
                                                              <div className="p-circle">
                                                                <img
                                                                  src={`https://elmsbk.aeontechhub.com/ProfilePic/${item.empId}/${item.empProfilePicName}`}
                                                                  width="75px"
                                                                  alt=""
                                                                />
                                                              </div>
                                                            </>
                                                          ) : (
                                                            <>
                                                              {item.gender ===
                                                              "Male" ? (
                                                                <>
                                                                  <img
                                                                    src="https://avatar.iran.liara.run/public/boy"
                                                                    width="75px"
                                                                    alt=""
                                                                  />
                                                                </>
                                                              ) : (
                                                                <>
                                                                  <img
                                                                    src="https://avatar.iran.liara.run/public/girl"
                                                                    width="75px"
                                                                    alt=""
                                                                  />
                                                                </>
                                                              )}
                                                            </>
                                                          )}
                                                          <div className="profile-info">
                                                            <span className="name">
                                                              {item.name}
                                                            </span>
                                                            <span className="desig">
                                                              {item.designation}
                                                            </span>
                                                          </div>
                                                        </div>
                                                        <div className="emp-info2">
                                                          <div className="d-flex gap-2">
                                                            <span>#</span>
                                                            <span>
                                                              #{item.empId}
                                                            </span>
                                                          </div>
                                                          <div className="d-flex gap-2">
                                                            <span>
                                                              <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="16"
                                                                height="16"
                                                                fill="currentColor"
                                                                className="bi bi-briefcase-fill"
                                                                viewBox="0 0 16 16"
                                                              >
                                                                <path d="M6.5 1A1.5 1.5 0 0 0 5 2.5V3H1.5A1.5 1.5 0 0 0 0 4.5v1.384l7.614 2.03a1.5 1.5 0 0 0 .772 0L16 5.884V4.5A1.5 1.5 0 0 0 14.5 3H11v-.5A1.5 1.5 0 0 0 9.5 1zm0 1h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5" />
                                                                <path d="M0 12.5A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5V6.85L8.129 8.947a.5.5 0 0 1-.258 0L0 6.85z" />
                                                              </svg>
                                                            </span>
                                                            <span>
                                                              {item.department}
                                                            </span>
                                                          </div>
                                                          <div className="d-flex gap-2">
                                                            {item.email !==
                                                            "" ? (
                                                              <>
                                                                <span>
                                                                  <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width="16"
                                                                    height="16"
                                                                    fill="currentColor"
                                                                    className="bi bi-envelope-fill"
                                                                    viewBox="0 0 16 16"
                                                                  >
                                                                    <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414zM0 4.697v7.104l5.803-3.558zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586zm3.436-.586L16 11.801V4.697z" />
                                                                  </svg>
                                                                </span>
                                                                <span>
                                                                  {item.email}
                                                                </span>
                                                              </>
                                                            ) : (
                                                              <>
                                                                <span>
                                                                  &nbsp;
                                                                </span>
                                                                <span>
                                                                  &nbsp;
                                                                </span>
                                                              </>
                                                            )}
                                                          </div>
                                                          <div className="d-flex gap-2">
                                                            {item.mobile !==
                                                            "" ? (
                                                              <>
                                                                <span>
                                                                  <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width="16"
                                                                    height="16"
                                                                    fill="currentColor"
                                                                    className="bi bi-telephone-fill"
                                                                    viewBox="0 0 16 16"
                                                                  >
                                                                    <path
                                                                      fillRule="evenodd"
                                                                      d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"
                                                                    />
                                                                  </svg>
                                                                </span>
                                                                <span>
                                                                  {item.mobile}
                                                                </span>
                                                              </>
                                                            ) : (
                                                              <>
                                                                <span>
                                                                  &nbsp;
                                                                </span>
                                                                <span>
                                                                  &nbsp;
                                                                </span>
                                                              </>
                                                            )}
                                                          </div>
                                                        </div>
                                                        <div className="cta d-flex gap-2 align-items-center justify-content-between">
                                                          <div className="joined-date">
                                                            <span>
                                                              Joined at
                                                              <strong>
                                                                {item.joiningDate !==
                                                                  "" && (
                                                                  <>
                                                                    {" "}
                                                                    {moment(
                                                                      item.joiningDate,
                                                                      "YYYY-MM-DD"
                                                                    ).format(
                                                                      "D MMM YYYY"
                                                                    )}
                                                                  </>
                                                                )}
                                                              </strong>
                                                            </span>
                                                          </div>
                                                          <button
                                                            onClick={(e) => {
                                                              showModal(
                                                                item.empId
                                                              );
                                                            }}
                                                            className="btn-transperent"
                                                          >
                                                            View Details
                                                            <span>
                                                              <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="16"
                                                                height="16"
                                                                fill="currentColor"
                                                                className="bi bi-arrow-right-short"
                                                                viewBox="0 0 16 16"
                                                              >
                                                                <path
                                                                  fillRule="evenodd"
                                                                  d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8"
                                                                />
                                                              </svg>
                                                            </span>
                                                          </button>
                                                        </div>
                                                      </Card>
                                                    </div>
                                                  </>
                                                );
                                              }
                                            )
                                          : null}
                                      </>
                                    )}
                                  </div>
                                </div>
                              </>
                            );
                          })
                        : null}
                    </div>
                  </div>
                </>
              )}
            </>
          )}
        </div>
        <div
          className={`${show ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setShow(false);
          }}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div
              className={`${
                show ? "filterByModal visible" : "filterByModal hidden"
              }`}
            >
              <div className="sort-list card">
                {selectedEmpData && (
                  <>
                    <div className="top">
                      <div
                        className={
                          selectedEmpData.isActive === "1"
                            ? "status Present"
                            : ""
                        }
                      >
                        <span>
                          {selectedEmpData.isActive === "1"
                            ? "Present"
                            : "Resigned"}
                        </span>
                      </div>
                    </div>

                    <p>Name: {selectedEmpData.name}</p>
                    <p>Email: {selectedEmpData.email}</p>
                    <p>Mobile: {selectedEmpData.mobileno}</p>
                    <p>
                      Date of Birth:{" "}
                      {selectedEmpData.dob !== "" && (
                        <>
                          {moment(selectedEmpData.dob, "YYYY-MM-DD").format(
                            "D MMMM YYYY"
                          )}
                        </>
                      )}
                    </p>
                    <p>Maritial Status: {selectedEmpData.maritial_Status}</p>

                    <hr />

                    <p>Designation: {selectedEmpData.designation}</p>
                    <p>Department: {selectedEmpData.department}</p>
                    <p>Role: {selectedEmpData.userRole}</p>
                    <p>Reparting Manager: {selectedEmpData.rmName}</p>
                    <p>Payroll: {selectedEmpData.payroll}</p>
                    <p>Location: {selectedEmpData.location}</p>
                    <p>
                      Joining Date:{" "}
                      {selectedEmpData.joiningdate !== "" && (
                        <>
                          {" "}
                          {moment(
                            selectedEmpData.joiningdate,
                            "YYYY-MM-DD"
                          ).format("D MMMM YYYY")}
                        </>
                      )}
                    </p>
                    <p>
                      Confirmation Date:{" "}
                      {selectedEmpData.comfirmation_date !== "" && (
                        <>
                          {" "}
                          {moment(
                            selectedEmpData.comfirmation_date,
                            "YYYY-MM-DD"
                          ).format("D MMMM YYYY")}
                        </>
                      )}
                    </p>
                    <p>{
                      selectedEmpData.isActive === "0" ? (<>
                      Last Working Date:{" "}
                       {selectedEmpData.lastWorkDay !== "" && (
                        <>
                          {" "}
                          {moment(
                            selectedEmpData.lastWorkDay,
                            "YYYY-MM-DD"
                          ).format("D MMMM YYYY")}
                        </>
                      )}
                      </>) : null}</p>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        <div
          className={`${show2 ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setShow2(false);
            setProfilePreview("");
          }}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div
              className={`${
                show2 ? "filterByModalNew visible" : "filterByModalNew hidden"
              }`}
            >
              <div className="sort-list">
                <h4 className="mb-3">Update Employee Information </h4>
                <Form
                  noValidate
                  validated={validated}
                  onSubmit={handleUpdateProfile}
                >
                  <div className="row">
                    <div className="col-lg-12">
                      <Form.Group className="mb-3">
                        <Form.Label>Profile Image </Form.Label>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 12,
                          }}
                        >
                          <div
                            onClick={triggerFileSelect}
                            role="button"
                            tabIndex={0}
                            onKeyPress={(e) =>
                              e.key === "Enter" && triggerFileSelect()
                            }
                            style={{
                              width: 75,
                              height: 75,
                              borderRadius: "50%",
                              overflow: "hidden",
                              background: "#f5f5f5",
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {profilePreview ? (
                              <img
                                src={profilePreview}
                                alt="preview"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                            ) : selectedEmpDataEdit &&
                              selectedEmpDataEdit.empProfilePicName ? (
                              <img
                                src={`https://elmsbk.aeontechhub.com/ProfilePic/${selectedEmpDataEdit.empId}/${selectedEmpDataEdit.empProfilePicName}`}
                                alt="current"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                            ) : (
                              <div style={{ color: "#999", fontSize: 12 }}>
                                No Image
                              </div>
                            )}
                            <Form.Control
                              ref={fileInputRef}
                              type="file"
                              accept="image/*"
                              onChange={handleProfileChange}
                              style={{ display: "none" }}
                            />
                          </div>
                        </div>
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          value={selectedEmpDataEdit.name}
                          onChange={handleInputChnage}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Designation</Form.Label>
                        <Form.Control
                          type="text"
                          name="designation"
                          value={selectedEmpDataEdit.designation}
                          onChange={handleInputChnage}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          value={selectedEmpDataEdit.email}
                          onChange={handleInputChnage}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Department </Form.Label>
                        <Form.Control
                          type="text"
                          name="department"
                          value={selectedEmpDataEdit.department}
                          onChange={handleInputChnage}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>DOB </Form.Label>
                        <Form.Control
                          type="date"
                          name="dob"
                          value={selectedEmpDataEdit.dob}
                          onChange={handleInputChnage}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Mobile No. </Form.Label>
                        <Form.Control
                          type="text"
                          name="mobileno"
                          value={selectedEmpDataEdit.mobileno}
                          onChange={handleInputChnage}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Location </Form.Label>
                        <Form.Select
                          aria-label="Default select example"
                          name="location"
                          value={selectedEmpDataEdit.location}
                          onChange={handleInputChnage}
                        >
                          <option>Select Location</option>
                          {Array.isArray(locations)
                            ? locations.map((item) => {
                                return (
                                  <option value={item.value}>
                                    {item.label}
                                  </option>
                                );
                              })
                            : null}
                        </Form.Select>
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Role </Form.Label>
                        <Form.Select
                          aria-label="Default select example"
                          name="userRoleId"
                          value={selectedEmpDataEdit.userRoleId}
                          onChange={handleInputChnage}
                        >
                          <option>Select Role</option>
                          {Array.isArray(roles)
                            ? roles.map((item) => {
                                return (
                                  <option value={item.value}>
                                    {item.label}
                                  </option>
                                );
                              })
                            : null}
                        </Form.Select>
                      </Form.Group>
                    </div>

                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>RM </Form.Label>
                        <Form.Select
                          aria-label="Default select example"
                          name="rMid"
                          value={selectedEmpDataEdit.rMid}
                          onChange={handleInputChnage}
                        >
                          <option>Select RM</option>
                          {Array.isArray(rmList)
                            ? rmList.map((item) => {
                                return (
                                  <option value={item.value}>
                                    {item.label}
                                  </option>
                                );
                              })
                            : null}
                        </Form.Select>
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>HR </Form.Label>
                        <Form.Select
                          aria-label="Default select example"
                          name="hR_id"
                          value={selectedEmpDataEdit.hR_id}
                          onChange={handleInputChnage}
                        >
                          <option>Select HR</option>
                          {Array.isArray(hrList)
                            ? hrList.map((item) => {
                                return (
                                  <option value={item.value}>
                                    {item.label}
                                  </option>
                                );
                              })
                            : null}
                        </Form.Select>
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Joining Date </Form.Label>
                        <Form.Control
                          type="date"
                          name="joiningdate"
                          value={selectedEmpDataEdit.joiningdate}
                          onChange={handleInputChnage}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Maritial Status </Form.Label>
                        <Form.Select
                          aria-label="Default select example"
                          name="maritial_Status"
                          value={selectedEmpDataEdit.maritial_Status}
                          onChange={handleInputChnage}
                        >
                          <option>Select</option>
                          {Array.isArray(marriedStatusOptions)
                            ? marriedStatusOptions.map((item) => {
                                return (
                                  <option value={item.value}>
                                    {item.label}
                                  </option>
                                );
                              })
                            : null}
                        </Form.Select>
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Chnage Status </Form.Label>
                        <Form.Check
                          type="switch"
                          id="custom-switch"
                          label={
                            selectedEmpDataEdit.isActive === "1"
                              ? "Active"
                              : "Resigned"
                          }
                          name="isActive"
                          checked={
                            selectedEmpDataEdit.isActive === "1" ? true : false
                          }
                          onChange={handleChangeStatus}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Last Working Day </Form.Label>
                        <Form.Control
                          type="date"
                          name="lastWorkDay"
                          value={selectedEmpDataEdit.lastWorkDay}
                          onChange={handleInputChnage}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>IsProbation </Form.Label>
                        <Form.Check
                          type="switch"
                          id="custom-switch1"
                          name="isprobationsts"
                          label={
                            selectedEmpDataEdit.isprobationsts === "1"
                              ? "Yes"
                              : "No"
                          }
                          checked={
                            selectedEmpDataEdit.isprobationsts === "1"
                              ? true
                              : false
                          }
                          onChange={handleChangeStatus}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Confirmation Date </Form.Label>
                        <Form.Control
                          type="date"
                          name="comfirmation_date"
                          value={selectedEmpDataEdit.comfirmation_date}
                          onChange={handleInputChnage}
                        />
                      </Form.Group>
                    </div>

                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>ESSL Code </Form.Label>
                        <Form.Control
                          type="text"
                          name="emp_EsslDeviceCode"
                          value={selectedEmpDataEdit.emp_EsslDeviceCode}
                          onChange={handleInputChnage}
                        />
                      </Form.Group>
                    </div>

                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Payroll </Form.Label>
                        <Form.Control
                          type="text"
                          name="payroll"
                          value={selectedEmpDataEdit.payroll}
                          onChange={handleInputChnage}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Leave Allocate Year </Form.Label>
                        <Form.Control
                          type="text"
                          name="leaveAllocateYear"
                          value={selectedEmpDataEdit.leaveAllocateYear}
                          onChange={handleInputChnage}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Allocated Leave </Form.Label>
                        <Form.Control
                          type="text"
                          name="allocatedLeave"
                          value={selectedEmpDataEdit.allocatedLeave}
                          onChange={handleInputChnage}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Yearly Balance </Form.Label>
                        <Form.Control
                          type="text"
                          name="yearlyBalLeave"
                          value={selectedEmpDataEdit.yearlyBalLeave}
                          onChange={handleInputChnage}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-lg-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Platform </Form.Label>
                       <Form.Select
                          aria-label="Default select example"
                          name="platform"
                          value={selectedEmpDataEdit.platform}
                          onChange={handleInputChnage}
                        >
                          <option>Select</option>
                          {Array.isArray(platformOptions)
                            ? platformOptions.map((item) => {
                                return (
                                  <option value={item.value}>
                                    {item.label}
                                  </option>
                                );
                              })
                            : null}
                        </Form.Select>
                      </Form.Group>
                    </div>
                    <div className="col-lg-12">
                      <Form.Group className="mb-3">
                        <Form.Label>Gender </Form.Label>
                        <div className="d-flex gap-2" key={`default-radio`}>
                          <Form.Check
                            type="radio"
                            id={`gender-male`}
                            name="gender"
                            value="Male"
                            label={`Male`}
                            checked={selectedEmpDataEdit.gender === "Male"}
                            onChange={handleGenderChange}
                          />
                          <Form.Check
                            type="radio"
                            id={`gender-female`}
                            name="gender"
                            value="Female"
                            label={`Female`}
                            checked={selectedEmpDataEdit.gender === "Female"}
                            onChange={handleGenderChange}
                          />
                        </div>
                      </Form.Group>
                    </div>
                    <div className="col-lg-12">
                      <div className="d-flex gap-2">
                        <button className="btn btn-primary" type="submit">
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CompanyHierarchy;
